<template>
<div id="lojas">
      
  <v-container grid-list-md text-xs-center>
      
    <v-flex xs12 >
          <v-progress-linear color="carregando" v-show="loading" :indeterminate="true"></v-progress-linear>
        <v-card  v-show="mostraLojas"  light class="white--text" color="primary">
        
              <v-card-title primary-title>
                <div class=" .pa-1 text-md-left headline">Lojas</div>
              </v-card-title>

              <v-list  three-line subheader="">
              
              <template v-for="(item, index) in lojas">
                <v-subheader v-if="item.header" :key="item.header">Lojas</v-subheader>
                <v-divider :key="index"></v-divider>
                <v-list-tile  :key="item.num_cartao"  @click="verExtrato(item.num_cartao)">
                  <v-list-tile-action>
                    <v-icon color="primary" size="45">location_on</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content >
                    <v-list-tile-title>Loja: {{ item.nome }}</v-list-tile-title>
                     <v-list-tile-sub-title>Bairro:  {{ item.bairro }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>Cidade: {{ item.cidade }}-{{item.uf}}</v-list-tile-sub-title>
                    
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>          
                        
              <v-spacer></v-spacer>
            
        
        </v-card>
        </v-flex>
  </v-container>

</div>
    
</template>

<script>
import { HTTP } from "../services/http.axios";

export default {
  data: () => ({
    lojas: {
      nome: "",
      bairro: "",
      cidade: "",
      uf: ""
    },
    mostraLojas: false
  }),
  mounted() {
    this.buscaLojas();
  },
  methods: {
    buscaLojas() {
      this.loading = true;

      HTTP.get(`/lojas/grupo/cliente`).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          this.lojas = response.data;
          this.mostraLojas = true;
        }
        this.loading = false;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Lojas.vue